import actiontypes from '../actiontypes'
import { Storage } from 'common-tools/StorageHelper'
import _ from 'common-tools/LodashHelper'
import { AuthAccountInfo } from 'common-classes/AuthAccountInfo'
import { AuthUserInfo } from 'common-classes/AuthUserInfo'

const CookieName = 'MRx'
let actions = {}

actions[actiontypes.CurrentSession.SetAccount] = (state, action) => {
  let newState = _.merge({}, state)
  newState.Token = action.payload.token
  Storage.Save(`${CookieName}Token`, action.payload.token)
  newState.Account = new AuthAccountInfo(action.payload.account)
  Storage.Save(`${CookieName}Account`, action.payload.account)
  return newState
}

actions[actiontypes.CurrentSession.UpdateAccount] = (state, action) => {
  let newState = _.merge({}, state)
  const { payload: newData = {} } = action
  const updateAccount = _.merge({}, newState.Account, newData)
  newState.Account = updateAccount
  Storage.Save(`${CookieName}Account`, updateAccount)
  return newState
}

actions[actiontypes.CurrentSession.ClearAccount] = (state, action) => {
  let newState = _.merge({}, state)
  newState.Token = ''
  Storage.Save(`${CookieName}Token`, '')
  newState.Account = new AuthAccountInfo()
  Storage.Save(`${CookieName}Account`, null)
  return newState
}

actions[actiontypes.CurrentSession.SetUser] = (state, action) => {
  let newState = _.merge({}, state)
  Storage.Save(`${CookieName}User`, action.payload.User)
  newState.User = new AuthUserInfo(action.payload.User)
  return newState
}

actions[actiontypes.CurrentSession.ClearUser] = (state, action) => {
  let newState = _.merge({}, state)
  Storage.Save(`${CookieName}User`, null)
  newState.User = new AuthUserInfo()
  return newState
}

actions[actiontypes.CurrentSession.SetDeviceFingerPrint] = (state, action) => {
  let newState = _.merge({}, state)
  newState.DeviceFingerPrint = action.payload
  return newState
}

actions[actiontypes.CurrentSession.ClearDeviceFingerPrint] = (state, action) => {
  let newState = _.merge({}, state)
  newState.DeviceFingerPrint = null
  return newState
}

actions[actiontypes.CurrentSession.ClearSettings] = (state, action) => {
  let newState = _.merge({}, state)
  newState.Settings = {}
  return newState
}

actions[actiontypes.CurrentSession.SetSettings] = (state, action) => {
  let newState = _.merge({}, state)

  const newSettings = action.payload.newSettings || []
  let settings = {}

  if (newSettings.length > 0) {
    _.each(newSettings, (ns) => {
      if (ns.Name) {
        settings[ns.Name] = ns.Value
      }
    })
  }

  newState.Settings = settings
  return newState
}

export default (
  state = {
    Token: Storage.Get(`${CookieName}Token`) || '',
    User: new AuthUserInfo(Storage.Get(`${CookieName}User`)),
    Account: new AuthAccountInfo(Storage.Get(`${CookieName}Account`)),
    Settings: {},
    DeviceFingerPrint: null
  }, action) => {
  if (_.startsWith(action.type, actiontypes.CurrentSession.Prefix)) {
    return actions[action.type](state, action)
  } else {
    return state
  }
}
